import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const layoutSlice = createSlice({
  name: "layout",
  initialState: {},
  reducers: {
    setLayout: (state: any, action: PayloadAction<any>) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setLayout } = layoutSlice.actions;

export default layoutSlice.reducer;
